/**
 * Bootstrap components initialization
 * Imports the components used by current templates.
 * jQuery references ($) are available globally via webpack externals.
 */
import Modal from 'bootstrap/js/dist/modal';
import Collapse from 'bootstrap/js/dist/collapse';
import Carousel from 'bootstrap/js/dist/carousel';

export function initBootstrapComponents() {
  // Components are now available globally for jQuery calls like:
  // $('selector').modal('toggle')
  // $('selector').modal('show')
  // $('selector').modal('hide')
  // and accordion/collapse behavior via data-toggle="collapse".
}

// Prevent tree-shaking from dropping side-effect component registrations.
void Modal;
void Collapse;
void Carousel;

// Initialize Bootstrap components on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBootstrapComponents);
} else {
  initBootstrapComponents();
}
